import { gpCommon } from '../app';

import type * as ng from 'angular';
import colorPickerDropdownTemplate from './color-picker-dropdown.html';

interface IColorPickerDropdownScope extends ng.IScope {
    showColorPicker: boolean;
    isOpen: boolean;
    onOpenClosed: (isOpen: boolean) => void;
    setDefaultColorSelected: () => void;
    selectedColor: string | null;
    defaultColor: string;
    isDefaultColorSelected: () => boolean;
    paletteClicked: () => void;
    viewColorPallete: () => void;
}

gpCommon.directive('gpColorPickerDropdown', ['$timeout', function ($timeout: ng.ITimeoutService) {
    let DEFAULT_COLOR = "rgba(129, 180, 252, 1)";


    function link(scope: IColorPickerDropdownScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) {
        let $scope = scope;
        let originalLeft: string | null = null;
        $scope.showColorPicker = false;
        $scope.isOpen = false;
        $scope.onOpenClosed = (isOpen: boolean) => {
            // any time the popup is shown/hidden, reset the originalLeft spot, 
            // because the popup might be in the different spot next time it is opened.
            originalLeft = null;
            if (isOpen) {
                // if we're opening it for the first time, it's possible the palette chooser was expanded out
                // so we need to check if it is on screen or not immediately.
                $timeout(() => ensurePanelIsOnScreen());
            }
        }

        function closeOnColorSelectIfNeeded() {
            // close on palette click if the color picker isn't open
            if (!$scope.showColorPicker) {
                $scope.isOpen = false;
            }
        }

        $scope.setDefaultColorSelected = () => {
            $scope.selectedColor = ($scope.defaultColor || DEFAULT_COLOR);
            closeOnColorSelectIfNeeded();
        }
        $scope.isDefaultColorSelected = () => $scope.selectedColor === ($scope.defaultColor || DEFAULT_COLOR);

        $scope.paletteClicked = () => {
            closeOnColorSelectIfNeeded();
        }

        scope.viewColorPallete = () => {
            $scope.showColorPicker = !$scope.showColorPicker;

            // if the palette is hidden, and we change colors before it is shown, then 
            // the circle and sliders don't show up in the right spot.
            //
            // HACK: So as a workaround we change the color value and change it back so 
            // the events trigger move the html elements to the right spot.

            if ($scope.showColorPicker) {
                let tempColor = $scope.selectedColor;

                $timeout(() => {
                    // by this time the palette has been shown so let's also check to see if the palette is off screen, and move it back on if we have to
                    ensurePanelIsOnScreen();

                    $scope.selectedColor = null;
                    $timeout(() => {
                        $scope.selectedColor = tempColor;
                    });
                });
            } else {
                // palette is hiding, so we should move the dropdown back to the original spot 
                if (originalLeft) {
                    let dropdownElem = $("body > div.gp-color-picker-dropdown");
                    dropdownElem.css('left', originalLeft);
                }
            }
        }

        function ensurePanelIsOnScreen() {
            let dropdownElem = $("body > div.gp-color-picker-dropdown");
            if (!originalLeft) {
                originalLeft = dropdownElem.css('left');
            }
            let offset = dropdownElem.offset();
            let width = dropdownElem.width();
            if (offset && width && (offset.left + width) > window.innerWidth) {
                let diff = (offset.left + width) - window.innerWidth;
                dropdownElem.css('left', `${offset.left - diff - 30}px`);
            }
        }
    }

    return {
        restrict: 'E',
        link: link,
        scope: {
            defaultColor: '=',
            selectedColor: '=',
        },
        template: colorPickerDropdownTemplate
    };

}]);
